module.exports = __webpack_public_path__ + "img/iso-certified.86b6b0f.svg";